import React, { useState, useEffect, useCallback, Fragment } from 'react'
import { useDispatch } from 'react-redux'
import { css } from '@emotion/react'
import cn from 'classnames'
import { Form } from 'util/ui'
import { TextDivider } from 'shared/ui'
import OAuthButton from 'components/OAuthButton'
import Button from '../../sharedForm/Button'
import PageHeader from '../PageHeader'
import sharedStyles from '../../sharedForm/styles.less'
import { doGoogleSignup, doEmailSignup } from './actions'
import { doRedirectIfAuthenticated } from '../actions'

const dividerStyle = css`
  margin: 32px 0;
`

const googleTracking = {
  category: 'oAuth-onboarding',
  action: 'oAuth-account-creation',
  label: 'oAuth-creation-Gmail',
}

const SignupPage = () => {
  const [saving, setSaving] = useState(false)
  const dispatch = useDispatch()
  useEffect(
    () => {
      dispatch(doRedirectIfAuthenticated(true))
    },
    [dispatch]
  )
  const doSignup = useCallback(
    action => {
      setSaving(true)
      dispatch(action()).catch(() => {
        setSaving(false)
      })
    },
    [setSaving, dispatch]
  )

  return (
    <Fragment>
      <PageHeader />
      <Form size="large" className={cn(sharedStyles.form, sharedStyles.formV3)}>
        <OAuthButton
          id="signup-google"
          key="google"
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => doSignup(doGoogleSignup)}
          iconName="googleLogo"
          text="Sign up with Google"
          savingText="Signing up…"
          saving={saving}
          tracking={googleTracking}
          dark
        />
        <TextDivider css={dividerStyle}>Or</TextDivider>
        <Button
          id="signup-email"
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => doSignup(doEmailSignup)}
          basic
          primary={false}
          className="lean-round"
          disabled={saving}
        >
          Sign up with email
        </Button>
      </Form>
      <p className="grui mt-12 text-center">
        By continuing, you agree to Groove&apos;s{' '}
        <span className="grui whitespace-nowrap">
          <a
            href="https://www.groovehq.com/our/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>{' '}
          and{' '}
          <a
            href="https://www.groovehq.com/our/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          .
        </span>
      </p>
    </Fragment>
  )
}

export default SignupPage
